import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendCustomTrackingInfo } from '@panel/commons';
import { Container, ContentBox, Title, Subtitle, CTA1, CTA2 } from './styles';

const Inicio = ({ device, handleClick, mapRef, plansRef }) => {
  const { t } = useTranslation();
  const siteId = process.env.REACT_APP_BUILD_SITE;

  return (
    <Container device={device} data-panel='landingZD-inicio'>
      <ContentBox device={device} data-panel='landingZD-inicio-box'>
        <Title device={device} data-panel='landingZD-inicio-title'>
          {t('panel.landing_ZD.inicio.title')}
        </Title>
        <Subtitle device={device} data-panel='landingZD-inicio-subtitle'>
          {t('panel.landing_ZD.inicio.subtitle.pre')} <strong>{t('panel.landing_ZD.inicio.subtitle.bold')}</strong>
          {t('panel.landing_ZD.inicio.subtitle.post')}
        </Subtitle>
        <CTA1
          device={device}
          data-panel='landingZD-inicio-CTA-buyPlans'
          onClick={() => {
            handleClick(plansRef, 'center');
            sendCustomTrackingInfo({
              event: 'select_content',
              content_type: 'CTAs landing',
              item_id: 'Comprar planes'
            });
          }}
        >
          {t('panel.landing_ZD.inicio.cta.zones')}
        </CTA1>

        <CTA2
          device={device}
          data-panel='landingZD-inicio-CTA-seeZones'
          onClick={() => {
            handleClick(mapRef, device === 'mobile' ? 'start' : 'center');
            sendCustomTrackingInfo({
              event: 'select_content',
              content_type: 'CTAs landing',
              item_id: 'Ver zonas'
            });
          }}
        >
          {t('panel.landing_ZD.inicio.cta.plans')}
        </CTA2>
      </ContentBox>
    </Container>
  );
};

export default Inicio;
